export default __webpack_public_path__ + "static/media/sunsculpted3.81fa0401.jpg";